import React from "react";
import PropTypes from "prop-types";

import { Link } from "@jsluna/link";
import { trackEvent, Card } from "@jsainsburyplc/id-ui-common";

import { getFindOutMoreLink } from "utils/urls";
import { categoryTypes, actionTypes } from "constants/tracking";

const trackLinkClick = () => {
  trackEvent({
    category: categoryTypes.MY_ID_CONFIRMATION_DIFF_PW,
    action: actionTypes.CLICK,
    label: "Find out more about My ID",
  });
};

const MyIdConfirmation = ({ passwordConflict }) => {
  return (
    <Card>
      {passwordConflict && (
        <>
          <h1 className="ln-u-h4">Great news, your My ID is all set up</h1>
          <p>
            You now only need to use one email and password to log in to both
            Nectar and Sainsbury’s Groceries.
          </p>
          <p>
            If you ever need to update your email or password, it will
            automatically update across both accounts.
          </p>
          <Link
            cta
            bare
            target="_blank"
            color="alpha"
            data-testid="find-out-more"
            href={getFindOutMoreLink()}
            onClick={trackLinkClick}
          >
            Find out more about My ID
          </Link>
        </>
      )}

      {!passwordConflict && (
        <>
          <h1 className="ln-u-h4">Great news, your My ID is ready to go</h1>
          <h2 className="ln-u-h5">What does it mean?</h2>
          <p>
            My ID is a service that makes accessing and managing your account
            easier.
          </p>
          <p>
            Now you can use the same email and password to log in to both Nectar
            and Sainsbury’s Groceries.
          </p>
          <p>
            If you ever need to update your password, it will automatically
            update across both accounts.
          </p>
          <p>
            We’ll be introducing new features and more Sainsbury’s brands to My
            ID in the future.
          </p>
        </>
      )}
    </Card>
  );
};

MyIdConfirmation.defaultProps = {
  passwordConflict: false,
};

MyIdConfirmation.propTypes = {
  passwordConflict: PropTypes.bool,
};

export default MyIdConfirmation;
